import { Fragment, ReactNode } from "react";

import { IActivationInstallment } from "./interfaces";

import { transformToCurrencyString } from "@/utils/TransformToCurrencyString";

type InvoicePaymentValues = Pick<
  IActivationInstallment,
  "monthlyFee" | "discount" | "installment"
>;

export function getInvoicePaymentDescription({
  monthlyFee,
  discount,
  installment
}: InvoicePaymentValues): ReactNode {
  if (installment < 1) return "";

  const discountAmount = discount ?? 0;
  const setupFeeAfterDiscount = Math.max(0, monthlyFee - discountAmount);
  let description: string;

  if (setupFeeAfterDiscount === 0) {
    description = "Sem cobrança na(s) fatura(s).";
  } else if (installment === 1) {
    description = `Cobrado na primeira fatura: ${transformToCurrencyString(setupFeeAfterDiscount)}.`;
  } else {
    const amountPerInvoice = Number(
      (setupFeeAfterDiscount / installment).toFixed(2)
    );

    description = `Parcelado em ${installment}x de ${transformToCurrencyString(amountPerInvoice)} na(s) ${installment} primeira(s) fatura(s).`;
  }

  if (discountAmount <= 0) return description;

  return (
    <Fragment>
      {description}
      <span className="discount-description">
        {` (Desconto de ${transformToCurrencyString(discountAmount)})`}
      </span>
    </Fragment>
  );
}
